import { useState } from "react";
import { API_FETCH_STATUS } from "constants/common";
import { fetchHeaderData } from "components/ABheader/services/ABheader.services";

const {SUCCESS,LOADING,ERROR} = API_FETCH_STATUS;

const useFetchHeader = () => {
  const [response, setResponse] = useState({ status: LOADING, content: null });
  const { status, content } = response;

  const fetchHeader = () => {
    setResponse({ ...response, status: LOADING });
    return fetchHeaderData()
      .then((response) => {
          setResponse({ status: SUCCESS, content: response });
      })
      .catch((error) => {
        setResponse({ status: ERROR, content: error });
      });
  };

  return { fetchHeader, status, content };
};

export default useFetchHeader;
